import React, { useCallback, useEffect } from 'react'
import { Text } from 'react-native-paper'
import Layout from '../Layout'
import { observer } from 'mobx-react'
import SubmitButton from '../SubmitButton'
import SignInStore from '../stores/SignInStore'
import RootStore from '../../../store/RootStore'
import Title, { SubTitle } from '../Title'
import { Link } from '../../../ui/atoms/Link'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Spacer } from '../../../ui/atoms'
import EmailInput from '../EmailInput'
import BackButton from '../BackButton'
import { paths } from '../../links'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from '../ErrorMessage'
import { event_names } from '../../../../../models/src/dictionaries/eventsNames'
import { callCustomEvent } from '../../../utils/helpers/callCustomEvent'

export default observer(({ navigation }) => {
  const { login, isValidEmail, setLogin } = SignInStore
  const { isBusy } = RootStore
  const { t } = useTranslation('auth')
  useEffect(() => SignInStore.removeError('forgot'), [])
  const pressSubmit = useCallback(() => {
    SignInStore.sendPasswordResetEmail().then(() => {
      callCustomEvent(event_names.forgot_password)
      navigation.navigate(paths.Auth.SignInForgotFinish)
    })
  }, [navigation])

  return (
    <Layout>
      <BackButton testID="back-button" />
      <Title>{t('signIn.forgotTitle')}</Title>
      <SubTitle style={{ marginTop: 20 }}>
        {t('signIn.forgotSubTitle')}
      </SubTitle>

      <EmailInput
        label={t('signIn.emailLabel')}
        value={login}
        onChangeText={setLogin}
        autoFocus
        onSubmitEditing={pressSubmit}
        hidden={false}
        placeholder={''}
      />
      <ErrorMessage error={SignInStore.errors.get('forgot')?.message} />
      <Spacer height={32} />
      <SubmitButton
        onPress={pressSubmit}
        disabled={!isValidEmail || isBusy}
        loading={isBusy}
      >
        {t('signIn.forgotSubmitLabel')}
      </SubmitButton>
      <Spacer />
      <Text
        style={{
          fontSize: 16,
          fontWeight: '500',
          color: commonColors.textLight,
        }}
      >
        {t('signIn.newUserQuestion')}
        <Link
          textStyle={{ fontSize: 16, fontWeight: '500' }}
          title={t('SignUp')}
          color={commonColors.accentText}
          onPress={() => navigation.replace(paths.Auth.SignUp)}
        />
      </Text>
    </Layout>
  )
})
